import { Component } from 'react';
import { useForm, ValidationError } from '@formspree/react';
import '../styles/VerticalLanding.css';

const VERTICALS = {
  clinics: {
    heroAr: 'توقف عن خسارة المرضى في واتساب',
    heroEn: 'Stop Losing Patients in WhatsApp',
    subtitleAr: 'شاهد كل عميل محتمل، من إعلان تيك توك إلى الموعد المحجوز، في مكان واحد.',
    subtitleEn: 'See every lead, from TikTok ad to booked appointment, in one place.',
    formId: 'mpqopgqn',
    whatsappMsg: 'أبي أعرف أكثر عن نظام إدارة العيادات',
    features: [
      {
        titleAr: 'إدارة الحملات الإعلانية',
        titleEn: 'Campaign Management',
        descAr: 'أدر حملاتك على تيك توك وسناب شات من لوحة تحكم واحدة. أنشئ حملات، تحكم بالميزانيات، وتابع الأداء.',
        descEn: 'Manage TikTok and Snapchat campaigns from one dashboard. Create campaigns, control budgets, track performance.',
        icon: '📊',
      },
      {
        titleAr: 'متابعة العملاء (CRM)',
        titleEn: 'Patient Pipeline (CRM)',
        descAr: 'تتبع كل مريض محتمل من الاستفسار إلى الموعد المحجوز. لا تنسى أي متابعة.',
        descEn: 'Track every patient from inquiry to booked appointment. Never miss a follow-up.',
        icon: '👥',
      },
      {
        titleAr: 'تكامل واتساب',
        titleEn: 'WhatsApp Integration',
        descAr: 'كل محادثات واتساب مع المرضى في مكان واحد. اعرف من أرسل ومن لم يرد عليه.',
        descEn: 'All patient WhatsApp conversations in one place. Know who messaged and who needs a reply.',
        icon: '💬',
      },
      {
        titleAr: 'تحليلات وتقارير',
        titleEn: 'Analytics & Reports',
        descAr: 'اعرف أي إعلان جاب أكثر مرضى، وكم تكلفة كل مريض جديد. قرارات مبنية على بيانات.',
        descEn: 'Know which ad brought the most patients and cost per acquisition. Data-driven decisions.',
        icon: '📈',
      },
    ],
    ctaAr: 'جرّب مجاناً',
    ctaEn: 'Try Free',
    formTitleAr: 'سجّل اهتمامك',
    formTitleEn: 'Register Your Interest',
    formSubtitleAr: 'سنتواصل معك خلال 24 ساعة لتفعيل حسابك المجاني.',
    formSubtitleEn: 'We will contact you within 24 hours to activate your free account.',
    pageTitle: 'ركين — متر مربع للعيادات | Rakeen — Square Meter for Clinics',
    screenshots: [
      { src: '/images/screenshot-dashboard-main.png', labelAr: 'لوحة التحكم والمحادثات', labelEn: 'Dashboard & Conversations' },
      { src: '/images/screenshot-campaigns.png', labelAr: 'إدارة الحملات الإعلانية', labelEn: 'Campaign Management' },
    ],
    vertical: 'clinics',
    verticalLabelAr: 'عيادات التجميل والأسنان',
    verticalLabelEn: 'Cosmetic & Dental Clinics',
  },
  'real-estate': {
    heroAr: 'كل عميل من سناب شات إلى توقيع العقد',
    heroEn: 'Every Lead from Snapchat to Signed Contract',
    subtitleAr: 'لا تخسر عميل واحد في واتساب. تابع كل استفسار من الإعلان إلى البيع.',
    subtitleEn: 'Never lose a lead in WhatsApp. Track every inquiry from ad to sale.',
    formId: 'mnjopkba',
    whatsappMsg: 'أبي أعرف أكثر عن نظام إدارة العقارات',
    features: [
      {
        titleAr: 'إدارة الحملات الإعلانية',
        titleEn: 'Campaign Management',
        descAr: 'أدر حملاتك على سناب شات وتيك توك من لوحة تحكم واحدة. شاهد الأداء لحظياً.',
        descEn: 'Manage Snapchat and TikTok campaigns from one dashboard. See performance in real-time.',
        icon: '📊',
      },
      {
        titleAr: 'متابعة العملاء (CRM)',
        titleEn: 'Lead Pipeline (CRM)',
        descAr: 'تتبع كل عميل محتمل من الاستفسار إلى زيارة الموقع إلى التفاوض إلى توقيع العقد.',
        descEn: 'Track every lead from inquiry to site visit to negotiation to signed contract.',
        icon: '🏗️',
      },
      {
        titleAr: 'تكامل واتساب',
        titleEn: 'WhatsApp Integration',
        descAr: 'كل محادثات العملاء في مكان واحد. اعرف من تواصل ومن يحتاج متابعة.',
        descEn: 'All client conversations in one place. Know who was contacted and who needs follow-up.',
        icon: '💬',
      },
      {
        titleAr: 'إدارة المخزون',
        titleEn: 'Inventory Management',
        descAr: 'تابع الوحدات والشقق: المتاح، المحجوز، المباع. ربط مباشر مع الصفقات.',
        descEn: 'Track units and apartments: available, reserved, sold. Direct link to deals.',
        icon: '🏢',
      },
    ],
    ctaAr: 'جرّب مجاناً',
    ctaEn: 'Try Free',
    formTitleAr: 'سجّل اهتمامك',
    formTitleEn: 'Register Your Interest',
    formSubtitleAr: 'سنتواصل معك خلال 24 ساعة لتفعيل حسابك المجاني.',
    formSubtitleEn: 'We will contact you within 24 hours to activate your free account.',
    pageTitle: 'ركين — متر مربع للعقارات | Rakeen — Square Meter for Real Estate',
    screenshots: [
      { src: '/images/screenshot-inventory.png', labelAr: 'المبيعات والمخزون', labelEn: 'Sales & Inventory' },
      { src: '/images/screenshot-snapchat.png', labelAr: 'إدارة حملات سناب شات', labelEn: 'Snapchat Campaigns' },
    ],
    vertical: 'real-estate',
    verticalLabelAr: 'التطوير العقاري والوساطة',
    verticalLabelEn: 'Real Estate Development & Brokerage',
  },
};

function VerticalForm({ formId, vertical, formTitleAr, formTitleEn, formSubtitleAr, formSubtitleEn }) {
  const [state, handleSubmit] = useForm(formId);

  if (state.succeeded) {
    return (
      <div className="vl-form-success">
        <div className="vl-form-success-icon">✓</div>
        <p className="vl-form-success-ar">شكراً لتسجيلك! سنتواصل معك قريباً.</p>
        <p className="vl-form-success-en">Thanks for registering! We'll contact you soon.</p>
      </div>
    );
  }

  return (
    <div className="vl-form-section" id="register">
      <h2 className="vl-form-title-ar">{formTitleAr}</h2>
      <p className="vl-form-title-en">{formTitleEn}</p>
      <p className="vl-form-subtitle-ar">{formSubtitleAr}</p>
      <p className="vl-form-subtitle-en">{formSubtitleEn}</p>
      <form className="vl-form" onSubmit={handleSubmit}>
        <input type="hidden" name="vertical" value={vertical} />
        <div className="vl-form-row">
          <div className="vl-form-field">
            <label htmlFor="name">الاسم / Name</label>
            <input id="name" name="name" type="text" required placeholder="محمد / Mohammed" />
          </div>
          <div className="vl-form-field">
            <label htmlFor="phone">رقم الجوال / Phone</label>
            <input id="phone" name="phone" type="tel" required placeholder="05XXXXXXXX" />
          </div>
        </div>
        <div className="vl-form-field">
          <label htmlFor="business">اسم النشاط / Business Name</label>
          <input id="business" name="business" type="text" required placeholder="اسم العيادة أو الشركة" />
        </div>
        <div className="vl-form-field">
          <label htmlFor="city">المدينة / City</label>
          <input id="city" name="city" type="text" placeholder="الرياض، جدة، الخبر..." />
        </div>
        <div className="vl-form-field">
          <label htmlFor="email">البريد الإلكتروني / Email</label>
          <input id="email" name="email" type="email" placeholder="email@example.com" />
          <ValidationError prefix="Email" field="email" errors={state.errors} className="vl-form-error" />
        </div>
        <button type="submit" className="vl-form-submit" disabled={state.submitting}>
          {state.submitting ? '...جاري الإرسال' : 'سجّل الآن — مجاناً'}
        </button>
        <ValidationError errors={state.errors} />
      </form>
    </div>
  );
}

const THEMES = [
  { id: 'midnight', label: 'Midnight', color: '#0A1628' },
  { id: 'desert', label: 'Desert', color: '#C8956C' },
  { id: 'oasis', label: 'Oasis', color: '#2D6A4F' },
  { id: 'arctic', label: 'Arctic', color: '#E8EDF2' },
];

class VerticalLanding extends Component {
  constructor(props) {
    super(props);
    const savedTheme = localStorage.getItem('vl-theme') || 'midnight';
    const savedDark = localStorage.getItem('vl-dark') !== 'false';
    this.state = { theme: savedTheme, darkMode: savedDark, lightboxSrc: null, lightboxLabel: null };
  }

  openLightbox = (src, label) => {
    this.setState({ lightboxSrc: src, lightboxLabel: label });
    document.body.style.overflow = 'hidden';
  };

  closeLightbox = () => {
    this.setState({ lightboxSrc: null, lightboxLabel: null });
    document.body.style.overflow = '';
  };

  componentDidMount() {
    const v = VERTICALS[this.props.verticalKey];
    if (v) {
      document.title = v.pageTitle;
    }
  }

  setTheme = (id) => {
    localStorage.setItem('vl-theme', id);
    this.setState({ theme: id });
  };

  toggleDarkMode = () => {
    const next = !this.state.darkMode;
    localStorage.setItem('vl-dark', next);
    this.setState({ darkMode: next });
  };

  render() {
    const { verticalKey } = this.props;
    const { theme, darkMode } = this.state;
    const v = VERTICALS[verticalKey];

    if (!v) {
      return <div style={{ padding: '80px 20px', textAlign: 'center' }}>Vertical not found.</div>;
    }

    const whatsappUrl = `https://wa.me/966505773806?text=${encodeURIComponent(v.whatsappMsg)}`;
    const year = new Date().getFullYear();
    const modeClass = darkMode ? 'vl-dark' : 'vl-light';

    return (
      <div className={`vl-root vl-theme-${theme} ${modeClass}`}>
        {/* Nav */}
        <nav className="vl-nav">
          <div className="vl-nav-inner">
            <a href="/" className="vl-nav-logo">
              <img src="/images/rakeen-logo.png" alt="Rakeen" className="vl-nav-logo-img" />
              <span className="vl-nav-logo-text">متر مربع</span>
            </a>
            <div className="vl-nav-links">
              <a href="#features" className="vl-nav-link">المميزات</a>
              <button
                className="vl-dark-toggle"
                onClick={this.toggleDarkMode}
                aria-label={darkMode ? 'الوضع الفاتح' : 'الوضع الداكن'}
                title={darkMode ? 'الوضع الفاتح' : 'الوضع الداكن'}
              >
                {darkMode ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="5"/>
                    <line x1="12" y1="1" x2="12" y2="3"/>
                    <line x1="12" y1="21" x2="12" y2="23"/>
                    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
                    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                    <line x1="1" y1="12" x2="3" y2="12"/>
                    <line x1="21" y1="12" x2="23" y2="12"/>
                    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
                    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
                  </svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                  </svg>
                )}
              </button>
              <a href="#register" className="vl-nav-link vl-nav-cta">{v.ctaAr}</a>
            </div>
          </div>
        </nav>

        {/* Theme Switcher */}
        <div className="vl-theme-switcher">
          {THEMES.map((t) => (
            <button
              key={t.id}
              className={`vl-theme-dot ${theme === t.id ? 'active' : ''}`}
              style={{ '--dot-color': t.color }}
              onClick={() => this.setTheme(t.id)}
              title={t.label}
              aria-label={`${t.label} theme`}
            />
          ))}
        </div>

        {/* Hero */}
        <section className="vl-hero">
          <div className="vl-hero-content">
            <span className="vl-hero-badge">{v.verticalLabelAr} — {v.verticalLabelEn}</span>
            <h1 className="vl-hero-title-ar">{v.heroAr}</h1>
            <p className="vl-hero-title-en">{v.heroEn}</p>
            <p className="vl-hero-subtitle-ar">{v.subtitleAr}</p>
            <p className="vl-hero-subtitle-en">{v.subtitleEn}</p>
            <div className="vl-hero-actions">
              <a href="#register" className="vl-btn-primary">{v.ctaAr}</a>
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="vl-btn-whatsapp">
                تواصل واتساب
              </a>
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="vl-features" id="features">
          <div className="vl-features-inner">
            <h2 className="vl-features-title-ar">كل ما تحتاجه في مكان واحد</h2>
            <p className="vl-features-title-en">Everything you need in one place</p>
            <div className="vl-features-grid">
              {v.features.map((f, i) => (
                <div key={i} className="vl-feature-card">
                  <span className="vl-feature-icon">{f.icon}</span>
                  <h3 className="vl-feature-title-ar">{f.titleAr}</h3>
                  <p className="vl-feature-title-en">{f.titleEn}</p>
                  <p className="vl-feature-desc-ar">{f.descAr}</p>
                  <p className="vl-feature-desc-en">{f.descEn}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Screenshots */}
        <section className="vl-screenshots">
          <div className="vl-features-inner">
            <h2 className="vl-features-title-ar">شاهد المنصة</h2>
            <p className="vl-features-title-en">See the platform in action</p>
            <div className="vl-screenshots-grid">
              {v.screenshots.map((s, i) => (
                <div
                  key={i}
                  className="vl-screenshot-card vl-screenshot-clickable"
                  onClick={() => this.openLightbox(s.src, s.labelAr)}
                >
                  <img src={s.src} alt={s.labelEn} className="vl-screenshot-img vl-screenshot-square" loading="lazy" />
                  <p className="vl-screenshot-label">{s.labelAr}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Form */}
        <VerticalForm
          formId={v.formId}
          vertical={v.vertical}
          formTitleAr={v.formTitleAr}
          formTitleEn={v.formTitleEn}
          formSubtitleAr={v.formSubtitleAr}
          formSubtitleEn={v.formSubtitleEn}
        />

        {/* Lightbox */}
        {this.state.lightboxSrc && (
          <div className="vl-lightbox-overlay" onClick={this.closeLightbox}>
            <div className="vl-lightbox-content" onClick={(e) => e.stopPropagation()}>
              <button className="vl-lightbox-close" onClick={this.closeLightbox}>&times;</button>
              <img src={this.state.lightboxSrc} alt={this.state.lightboxLabel} className="vl-lightbox-img" />
              <p className="vl-lightbox-label">{this.state.lightboxLabel}</p>
            </div>
          </div>
        )}

        {/* Footer */}
        <footer className="vl-footer">
          <div className="vl-footer-inner">
            <span>&copy; {year} Rakeen — متر مربع</span>
            <div className="vl-footer-links">
              <a href="/privacy">Privacy</a>
              <a href="/terms">Terms</a>
              <a href="/contact">Contact</a>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

// Wrapper components for routing
export function ClinicsLanding() {
  return <VerticalLanding verticalKey="clinics" />;
}

export function RealEstateLanding() {
  return <VerticalLanding verticalKey="real-estate" />;
}

export default VerticalLanding;
